import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { DataLoaderService } from './data-loader.service';
import { SummaryService } from './summary.service';
import { PriceCalculationService } from './price-calculation.service';
import { VehicleInfoService } from './vehicle-info.service';
import { Subscription } from 'rxjs/Subscription';
import { CommonDataService } from "./common-data.service";
import * as CryptoJS from 'crypto-js';
import { TokenEncrption } from './encryption-File.service';

@Injectable()
export class SummaryValidationService {
    public headers:any
    public headerOptions:any

    // public baseUrl = 'http://BLRKEC401264D:8080';
    public baseUrl = this.dataLoaderService.baseUrl;
    public path = this.dataLoaderService.path;
    public collectArray = [];
    public selectedVehicleInfo: any;
    public validateResponse: any;
    public subscription: Subscription;
    private color;
    private additionalColor;
    private rim;
    private upholstery;
    private trim;
    private expertColor;
    private expertAdditionalColor;
    private expertRim;
    private expertUpholstery;
    private expertTrim;
    public imageURL: String;
    public acceptInternalCodes: any;
    public lang: any;
    public flag: any;
    public ppmPreviousHiddenOptions: any;
    public ppmPreviousInternalOptions: any
    public requestOptions:any;
    public selectedNormalOptionsDictionary = {
        'selectedFactory': [], 'selectedLocal': [], 'selectedPackage': [], 'selectedLocalPackage': [], 'selectedStandard': []
    }
    public vehicleInfo: any;
    public selectedExpertOptionsDictionary = {
        'selectedExpertFactory': [], 'selectedExpertLocal': [], 'selectedExpertPackage': [], 'selectedExpertLocalPackage': [], 'selectedStandard': []
    }
    encryptedToken: any;
    internalCodes: any;
    otherCodesForValidation: any;

    constructor(private http: Http, private priceCalculationService: PriceCalculationService,
        private dataLoaderService: DataLoaderService, private vehicleInfoService: VehicleInfoService,
        private summaryService: SummaryService, private commonDataService: CommonDataService,private tokenEncrption:TokenEncrption) {
        this.selectedVehicleInfo = this.vehicleInfoService.extractData();
        this.encryptedToken =   tokenEncrption.getencryptedToken();
        this.vehicleInfo = this.vehicleInfoService.extractData();
        this.subscription = this.commonDataService.notifyObservableLanguage$.subscribe((lang) => {
            this.lang = lang.data;
        });

        //DFE
        let x = window.location.search.replace(/\+/g, '%20');
        let uricomponents = decodeURIComponent(x).substring(1).split('&');
        for (let i = 0; i < uricomponents.length; i++) {
            let pair = uricomponents[i].split('=');
        if (pair[0] === 'authToken'){
                let accesstokenkey = pair[1];
           
        this.headerOptions = {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
           'Authorization-Token': this.encryptedToken,
        }
         this.requestOptions = {
            headers: new Headers(this.headerOptions)
        };
	}
		}	
        //SWT
        
        console.log(this.requestOptions);
        if(this.headerOptions==undefined){
			const headerOptions = {
				'Content-Type': 'application/json',
				'Access-Control-Allow-Origin': '*',
				'Authorization-Token': this.encryptedToken,
			}
			 this.requestOptions = {
				headers: new Headers(headerOptions)
			};
		}
    }

    getColor() {
        return this.color;
    }

    getUpholstery() {
        return this.upholstery;
    }

    getSelectedOptions() {
        this.subscription = this.priceCalculationService.notifyObservableNormalComp$.subscribe((selectedOption) => {
            if (selectedOption.fromComponent == "normalColor") {
                this.color = selectedOption.data[0];
            } else if (selectedOption.fromComponent == "normalAddColor") {
                if (selectedOption.data != undefined)
                    this.additionalColor = selectedOption.data[0];
            } else if (selectedOption.fromComponent == "normalTrim") {
                this.trim = selectedOption.data[0];
            } else if (selectedOption.fromComponent == "normalRim") {
                this.rim = selectedOption.data[0];
            } else if (selectedOption.fromComponent == "normalUpholstery") {
                this.upholstery = selectedOption.data[0];
            } else if (selectedOption.fromComponent == "normalStandard") {
                this.selectedNormalOptionsDictionary.selectedStandard = (selectedOption.data[0]);
            }

        });

        this.subscription = this.priceCalculationService.notifyObservableExpertComp$.subscribe((selectedOption) => {
            if (selectedOption.fromComponent == "expertColor") {
                this.color = selectedOption.data[0];
            } else if (selectedOption.fromComponent == "expertAddColor") {
                if (selectedOption.data != undefined)
                    this.additionalColor = selectedOption.data[0];
            } else if (selectedOption.fromComponent == "expertTrim") {
                this.trim = selectedOption.data[0];
            } else if (selectedOption.fromComponent == "expertRim") {
                this.rim = selectedOption.data[0];
            } else if (selectedOption.fromComponent == "expertUpholstery") {
                this.upholstery = selectedOption.data[0];
            } else if (selectedOption.fromComponent == "expertStandard") {
                this.selectedExpertOptionsDictionary.selectedStandard = (selectedOption.data[0]);
            }
        });
    }

    changeLanguage(postData) {
        let windowURL = postData;
        let langFirst = windowURL.search(/language/i);
        let subLang = windowURL.substr(langFirst, 14);
        if (this.lang === undefined)
            this.lang = this.dataLoaderService.vehicleInfo.language;
        let replacedLang = "language\":" + "\"" + this.lang.toUpperCase() + "\"";
        let changedURL = windowURL.replace(subLang, replacedLang);

        let langSecond = changedURL.search(/languageCode/i);
        let subLangCode = changedURL.substr(langSecond, 18);
        if (this.lang === undefined)
            this.lang = this.dataLoaderService.vehicleInfo.language;
        let replacedLangCode = "languageCode\":" + "\"" + this.lang.toUpperCase() + "\"";
        let changedURLCode = changedURL.replace(subLangCode, replacedLangCode);

        let langThird = changedURLCode.search(/documentLanguage/i);
        let subDocLang = changedURLCode.substr(langThird, 22);
        if (this.lang === undefined)
            this.lang = this.dataLoaderService.vehicleInfo.language;
        let replacedDocLang = "documentLanguage\":" + "\"" + this.lang + "\"";
        let changedURLDoc = changedURLCode.replace(subDocLang, replacedDocLang);

        return changedURLDoc;
    }

    /*getSummaryValidationData() {
        let color: any;
        let trim: any;
        let rim: any;
        let upholstery: any;
        let additionalColor: any;
        let expertColor: any;
        let expertTrim: any;
        let expertRim: any;
        let expertUpholstery: any;
        let expertAdditionalColor: any;
     //DFE
		let x = window.location.search.replace(/\+/g, '%20');
        let uricomponents = decodeURIComponent(x).substring(1).split('&');
        for (let i = 0; i < uricomponents.length; i++) {
            let pair = uricomponents[i].split('=');
        if (pair[0] === 'authToken'){
                let accesstokenkey = pair[1];
           
        this.headerOptions = {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Authorization-Token': accesstokenkey,
            'parturl': this.dataLoaderService.parturl,
        }
         this.requestOptions = {
            headers: new Headers(this.headerOptions)
        };
	}
		}	
        //SWT
        // console.log(this.requestOptions);
        if(this.headerOptions==undefined){
			const headerOptions = {
				'Content-Type': 'application/json',
				'Access-Control-Allow-Origin': '*',
				'Authorization-Token': this.encryptedToken,
			}
			 this.requestOptions = {
				headers: new Headers(headerOptions)
			};
		}

        if (this.trim == undefined) {
            this.trim = 'nil';
        }
        if (this.rim == undefined) {
            this.rim = 'nil';
        }
        if (this.dataLoaderService.flagDictionary.modeFlag !== 'expert' && this.color !== undefined || this.trim !== undefined || this.rim !== undefined && this.upholstery !== undefined) {
            this.dataLoaderService.getSavedConfig();
            this.dataLoaderService.getOtherCodesConfig();
            this.summaryService.mergingStdWithSelectedNormal();
        }
        else if (this.dataLoaderService.flagDictionary.modeFlag === 'expert' && this.color !== undefined || this.trim !== undefined || this.rim !== undefined && this.upholstery !== undefined) {
            this.dataLoaderService.getSavedConfig();
            this.dataLoaderService.getOtherCodesConfig();
            this.summaryService.mergingStdWithSelectedExpert();
        }

        if (this.color) {
            color = JSON.stringify(this.color.code);
        }
        else {
            color = '\"000\"';
        }
        if (this.upholstery) {
            upholstery = JSON.stringify(this.upholstery.code);
        }
        else {
            
            upholstery = '\"000\"'
        }
        if (this.dataLoaderService.data.vehInfo[0].model === 'SMRT' || this.dataLoaderService.data.additionalColor.length > 0) {

            if (this.additionalColor !== undefined) {

                additionalColor = JSON.stringify(this.additionalColor.code);

            } else {
                additionalColor = '\"000\"';
            }
        } else {
            additionalColor = '\"000\"';
        }

        if ((this.color !== undefined || this.upholstery !== undefined) || this.trim !== undefined || this.rim !== undefined) {
            let validateData: String;
            let otherOptionCodes = [];
            let otherCodes = [];
            
            for (let index in this.summaryService.selectedCollectArray) {
                if (this.summaryService.selectedCollectArray[index] != undefined)
                    otherOptionCodes.push(this.summaryService.selectedCollectArray[index].code);
            }
            
            for (let i in this.dataLoaderService.hiddenOptions) {
                 otherCodes.push(this.dataLoaderService.hiddenOptions[i].code);
                
     
            }
            // checking hiddenCodes
            this.ppmPreviousHiddenOptions = otherCodes ;
            
            for (let i = 0; i < otherCodes.length; i++) {
                 otherOptionCodes.push(otherCodes[i]);  //hidden options
                 console.log("otherOptionCodes----------1",otherOptionCodes);
                 
            }
            
            for (let i in this.dataLoaderService.amendInternalCodes) {
                otherOptionCodes.push(this.dataLoaderService.amendInternalCodes[i].code); // internal codes
                console.log("otherOptionCodes----------2",otherOptionCodes);
            }
            otherOptionCodes = otherOptionCodes.filter((el, i, a) => i === a.indexOf(el))
            console.log("otherOptionCodes----------3",otherOptionCodes);
            let postData = this.selectedVehicleInfo.savedConfig.split('lowerPaint')[0];
            console.log("postData----------4",postData);
            postData = this.changeLanguage(postData);
            console.log("postData----------5",postData);
            const data = JSON.parse(this.vehicleInfo.savedConfig);
            console.log("data----------6",data);
            this.internalCodes = data.internalCodes;
            console.log("this.internalCodes----------7",this.internalCodes);            
            this.otherCodesForValidation = data.otherCodes;
            console.log("this.internalCodes----------8",this.otherCodesForValidation);
            if(this.internalCodes!=undefined){                
            validateData = postData.substring(0, postData.length - 1)
                + '\"lowerPaint\":' + color
                + ',\"upholstery\":' + upholstery
                + ',\"upperPaint\":' + additionalColor
                + ',\"urlFlag\":' + 2
                + ',\"otherCodes\":' + JSON.stringify(this.otherCodesForValidation)
                + ',\"internalCodes\":' + JSON.stringify(this.internalCodes)
                + '}';
                console.log("Payload--with internal code->",validateData);
            }else{
               validateData = postData.substring(0, postData.length - 1)
                + '\"lowerPaint\":' + color
                + ',\"upholstery\":' + upholstery
                + ',\"upperPaint\":' + additionalColor
                + ',\"urlFlag\":' + 2
                + ',\"otherCodes\":' + JSON.stringify(this.otherCodesForValidation)
                + '}'; 
                console.log("Payload--without internal code->",validateData);
            }

            
            

            return this.http.post(this.baseUrl + this.path + this.selectedVehicleInfo.internalVehicleId + '/analysis', validateData, this.requestOptions)
            // return this.http.post(this.baseUrl + this.path + 'analysis/' + this.selectedVehicleInfo.internalVehicleId , validateData, this.requestOptions)
                .map((response) => {
                    let data = response.json();
                    if (data) {
                        this.validateResponse = data
                    }
                    
                    this.dataLoaderService.hiddenCodesValidationRes = this.validateResponse.hiddenCodes;
                    this.dataLoaderService.amendUpdatedPrices = this.validateResponse.priceValues;
                    //updating latest hiddenCodes
                    this.dataLoaderService.hiddenOptions = this.validateResponse.hiddenCodes;
                    this.dataLoaderService.internalCodes = this.validateResponse.internalCodes;
                    this.dataLoaderService.amendInternalCodes = this.validateResponse.internalCodes;
                    
                    return (this.validateResponse);
                },
                (err) => {
                    if (err.status === 500) {
                        if (JSON.stringify(err._body).includes('details')) {
                            this.dataLoaderService.errorMessage = err._body;
                        } else if (!JSON.stringify(err._body).includes('details')) {
                            this.dataLoaderService.errorMessage = JSON.parse(err._body);
                            if (this.dataLoaderService.errorMessage == "") {
                                this.dataLoaderService.errorMessage = "Configurator Application is Down. Please try later."
                            }
                        } else {
                            this.dataLoaderService.errorMessage = "Configurator Application is Down. Please try later."
                        }
                    } else if (err.status === 404) {
                        if (JSON.stringify(err._body).includes('details')) {
                            this.dataLoaderService.errorMessage = err._body;
                        } else if (!JSON.stringify(err._body).includes('details')) {
                            this.dataLoaderService.errorMessage = JSON.parse(err._body);
                            if (this.dataLoaderService.errorMessage == "") {
                                this.dataLoaderService.errorMessage = "Configurator Application is Down. Please try later."
                            }
                        } else {
                            this.dataLoaderService.errorMessage = "Configurator Application is Down. Please try later."
                        }
                    } else {
                        if (JSON.stringify(err._body).includes('details')) {
                            this.dataLoaderService.errorMessage = err._body;
                        } else if (!JSON.stringify(err._body).includes('details')) {
                            this.dataLoaderService.errorMessage = JSON.parse(err._body);
                            if (this.dataLoaderService.errorMessage == "") {
                                this.dataLoaderService.errorMessage = "Configurator Application is Down. Please try later."
                            }
                        } else {
                            this.dataLoaderService.errorMessage = "Configurator Application is Down. Please try later."
                        }
                    }
                    // this.dataLoaderService.flagDictionary.loadingFlag = false;
                    this.dataLoaderService.flagDictionary.exceptionFlag = true;
                }
                );
        }
    }*/

    getSummaryValidationData() {
        let color: any;
        let trim: any;
        let rim: any;
        let upholstery: any;
        let additionalColor: any;
        let expertColor: any;
        let expertTrim: any;
        let expertRim: any;
        let expertUpholstery: any;
        let expertAdditionalColor: any;
        this.encryptedToken =   this.tokenEncrption.getencryptedToken();
		
            const headerOptions = {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization-Token': this.encryptedToken,
            }
             this.requestOptions = {
                headers: new Headers(headerOptions)
            };

        if (this.trim == undefined) {
            this.trim = 'nil';
        }
        if (this.rim == undefined) {
            this.rim = 'nil';
        }
        if (this.dataLoaderService.flagDictionary.modeFlag !== 'expert' && this.color !== undefined || this.trim !== undefined || this.rim !== undefined && this.upholstery !== undefined) {
            this.dataLoaderService.getSavedConfig();
            this.dataLoaderService.getOtherCodesConfig();
            this.summaryService.mergingStdWithSelectedNormal();
        }
        else if (this.dataLoaderService.flagDictionary.modeFlag === 'expert' && this.color !== undefined || this.trim !== undefined || this.rim !== undefined && this.upholstery !== undefined) {
            this.dataLoaderService.getSavedConfig();
            this.dataLoaderService.getOtherCodesConfig();
            this.summaryService.mergingStdWithSelectedExpert();
        }

        if (this.color) {
            color = JSON.stringify(this.color.code);
        }
        else {
            color = '\"000\"';
        }
        if (this.upholstery) {
            upholstery = JSON.stringify(this.upholstery.code);
        }
        else {
            
            upholstery = '\"000\"'
        }
        if (this.dataLoaderService.data.vehInfo[0].model === 'SMRT' || this.dataLoaderService.data.additionalColor.length > 0) {

            if (this.additionalColor !== undefined) {

                additionalColor = JSON.stringify(this.additionalColor.code);

            } else {
                additionalColor = '\"000\"';
            }
        } else {
            additionalColor = '\"000\"';
        }

        if ((this.color !== undefined || this.upholstery !== undefined) || this.trim !== undefined || this.rim !== undefined) {
            let validateData: String;
            let otherOptionCodes = [];
            let otherCodes = [];
            
            for (let index in this.summaryService.selectedCollectArray) {
                if (this.summaryService.selectedCollectArray[index] != undefined)
                    otherOptionCodes.push(this.summaryService.selectedCollectArray[index].code);
            }
            
            for (let i in this.dataLoaderService.hiddenOptions) {
                console.log("Hidden Codes - > "+ this.dataLoaderService.hiddenOptions[i].code);
                 otherCodes.push(this.dataLoaderService.hiddenOptions[i].code);
                
     
            }
            // checking hiddenCodes
            this.ppmPreviousHiddenOptions = otherCodes ;
            
            for (let i = 0; i < otherCodes.length; i++) {
                 otherOptionCodes.push(otherCodes[i]);  //hidden options
            }
            console.log("this.dataLoaderService.amendInternalCodes", this.dataLoaderService.amendInternalCodes);
            
            
            for (let i in this.dataLoaderService.amendInternalCodes) {
                otherOptionCodes.push(this.dataLoaderService.amendInternalCodes[i].code); // internal codes
            }
            otherOptionCodes = otherOptionCodes.filter((el, i, a) => i === a.indexOf(el))
            let postData = this.selectedVehicleInfo.savedConfig.split('lowerPaint')[0];
            postData = this.changeLanguage(postData);

            // validateData = postData.substring(0, postData.length - 1)
            //     + '\"lowerPaint\":' + color
            //     + ',\"upholstery\":' + upholstery
            //     + ',\"upperPaint\":' + additionalColor
            //     + ',\"urlFlag\":' + this.vehicleInfo.urlFlag
            //     + ',\"otherCodes\":' + JSON.stringify(otherOptionCodes)
            //      + ',\"internalCodes\":' + JSON.stringify(this.internalCodes)

            validateData = postData.substring(0, postData.length - 1)
                + '\"lowerPaint\":' + color
                + ',\"upholstery\":' + upholstery
                + ',\"upperPaint\":' + additionalColor
                + ',\"urlFlag\":' + this.vehicleInfo.urlFlag
                + ',\"otherCodes\":' + JSON.stringify(otherOptionCodes)
                + '}';
                console.log("Payload-", validateData);
                
            // validateDaa = '{ "language": "EN", "vehicle": "smart+fortwo+cabrio", "priceBpmBm": "186700.41", "configurationDate": "20161226", "orderingMarket": "819", "pricingDate": "20161226", "salesLevel": "W", "taxDate": "20161226", "materialType": "SMRT", "productIdERP": "45148010-CN5", "majorVersion": "1", "infoId": "SUTHOJU", "messageMode": "parametersAndText", "systemId": "ALLG", "evaluationDate": "20161226", "baumuster": "45148010", "languageCode": "EN", "gear": "GA", "owner": "819", "ownerMarketLayer": "537", "bookingSalesUnit": "53700", "consumerCountry": "819", "transactionTypeMarket": "DLBZ", "customerStock": "BEST", "documentLanguage": "en", "flagSalesMode": "true", "orderDate": "20161226", "plannedFinalInspectionDate": "20161212", "nstCode": "CN5", "totalPrice": "186700.41", "checkDate": "20161226", "valuationContent": "", "productionDate": "20161226", "viewId": "BEWR", "lowerPaint": "EN8", "upperPaint": "EAI", "upholstery": "IBE", "otherCodes": ["I01", "E81", "V11", "I35", "986", "V43", "989", "I31", "R01", "U51", "I63", "V33", "I32", "K09", "X21", "K03", "K01", "K02", "R25", "X72", "X73", "S02", "I53", "S22", "929", "V26", "830", "V21", "H19"] }';
            return this.http.post(this.baseUrl + this.path + this.selectedVehicleInfo.internalVehicleId + '/analysis', validateData, this.requestOptions)
                .map((response) => {
                    let data = response.json();
                    if (data) {
                        this.validateResponse = data
                    }
                    
                    this.dataLoaderService.hiddenCodesValidationRes = this.validateResponse.hiddenCodes;
                    this.dataLoaderService.amendUpdatedPrices = this.validateResponse.priceValues;
                    //updating latest hiddenCodes
                    this.dataLoaderService.hiddenOptions = this.validateResponse.hiddenCodes;
                    this.dataLoaderService.internalCodes = this.validateResponse.internalCodes;
                    this.dataLoaderService.amendInternalCodes = this.validateResponse.internalCodes;
                    
                    return (this.validateResponse);
                },
                (err) => {
                    if (err.status === 500) {
                        if (JSON.stringify(err._body).includes('details')) {
                            this.dataLoaderService.errorMessage = err._body;
                        } else if (!JSON.stringify(err._body).includes('details')) {
                            this.dataLoaderService.errorMessage = JSON.parse(err._body);
                            if (this.dataLoaderService.errorMessage == "") {
                                this.dataLoaderService.errorMessage = "Configurator Application is Down. Please try later."
                            }
                        } else {
                            this.dataLoaderService.errorMessage = "Configurator Application is Down. Please try later."
                        }
                    } else if (err.status === 404) {
                        if (JSON.stringify(err._body).includes('details')) {
                            this.dataLoaderService.errorMessage = err._body;
                        } else if (!JSON.stringify(err._body).includes('details')) {
                            this.dataLoaderService.errorMessage = JSON.parse(err._body);
                            if (this.dataLoaderService.errorMessage == "") {
                                this.dataLoaderService.errorMessage = "Configurator Application is Down. Please try later."
                            }
                        } else {
                            this.dataLoaderService.errorMessage = "Configurator Application is Down. Please try later."
                        }
                    } else {
                        if (JSON.stringify(err._body).includes('details')) {
                            this.dataLoaderService.errorMessage = err._body;
                        } else if (!JSON.stringify(err._body).includes('details')) {
                            this.dataLoaderService.errorMessage = JSON.parse(err._body);
                            if (this.dataLoaderService.errorMessage == "") {
                                this.dataLoaderService.errorMessage = "Configurator Application is Down. Please try later."
                            }
                        } else {
                            this.dataLoaderService.errorMessage = "Configurator Application is Down. Please try later."
                        }
                    }
                    // this.dataLoaderService.flagDictionary.loadingFlag = false;
                    this.dataLoaderService.flagDictionary.exceptionFlag = true;
                }
                );
        }
    }

}





// WEBPACK FOOTER //
// ./src/app/services/summary-validation.service.ts